import { render } from "./ButtonReset.vue?vue&type=template&id=c4098f32"
import script from "./ButtonReset.vue?vue&type=script&lang=js"
export * from "./ButtonReset.vue?vue&type=script&lang=js"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__